const util = require('./util')

class ReportProfile {
  constructor (config) {
    this.saveUrl = `/${config.domain}/report`
    this.form = document.querySelector('.report-profile')
    this.thanks = document.querySelector('.report-profile-thanks')
    this.saveButton = document.querySelector('.report-profile__send-button')

    util.addClass(document.body, 'hide-intercom')

    this.form.addEventListener('input', this.updateFormState.bind(this))
    this.form.addEventListener('change', this.updateFormState.bind(this)) // checkboxes only fire 'change'
    this.form.addEventListener('submit', this.saveReport.bind(this))
  }

  getTarget () {
    const profileChecked = document.querySelector('#report-target-profile').checked
    const websiteChecked = document.querySelector('#report-target-website').checked
    if (profileChecked) {
      return websiteChecked ? 'both' : 'profile'
    }
    return websiteChecked ? 'website' : null
  }

  getUrl () {
    return document.querySelector('#report-target-url').value
  }

  getReason () {
    return document.querySelector('#report-reason').value
  }

  getDetails () {
    return document.querySelector('#report-details').value
  }

  getEmail () {
    return document.querySelector('#report-email').value
  }

  updateFormState () {
    const urlInput = document.querySelector('#report-target-url')
    const target = this.getTarget()
    const urlRequired = target === 'website' || target === 'both'
    if (urlRequired) {
      urlInput.removeAttribute('disabled')
    } else {
      urlInput.setAttribute('disabled', '')
    }

    const targetSelected = Boolean(target)
    const urlProvided = !urlRequired || Boolean(this.getUrl())
    const reasonSelected = Boolean(this.getReason())
    const detailsProvided = Boolean(this.getDetails())
    const emailProvided = Boolean(this.getEmail())
    if (targetSelected && urlProvided && reasonSelected && detailsProvided && emailProvided) {
      this.saveButton.removeAttribute('disabled')
    } else {
      this.saveButton.setAttribute('disabled', '')
    }
  }

  showThanks () {
    util.addClass(this.form, 'hidden')
    util.removeClass(this.thanks, 'hidden')
  }

  showError () {
    const errorMessage = document.querySelector('.report-profile-error')
    util.addClass(errorMessage, 'hidden')
    util.removeClass(errorMessage, 'hidden')
  }

  saveReport (event) {
    event.preventDefault()
    const report = {
      target: this.getTarget(),
      url: this.getUrl(),
      reason: this.getReason(),
      details: this.getDetails(),
      email: this.getEmail()
    }
    util.postJson(this.saveUrl, { report }).then(json => {
      this.showThanks()
    }).catch(err => {
      this.showError(err)
    })
  }
}

function main () {
  return new ReportProfile(window.config)
}

require('./booter').boot(main)
